const baseUrl: string = process.env.REACT_APP_API_URL || '';

class Banner {
    private uri: string;

    constructor(uri: string) {
        this.uri = uri;
    }

    public read = (params: any) => ({
        baseUrl,
        method: 'get',
        params,
        uri: this.uri,
    });

    public post = (params: any) => ({
        baseUrl,
        method: 'post',
        params,
        uri: this.uri,
    });
}

export default new Banner('/cms/v1/banners');



// WEBPACK FOOTER //
// ./src/libraries/api/banners.tsx